import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import projectService from "../../services/projectService";


export function CaseCard({ title, category, image, description, slug }) {
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="1000"
      className="col-span-6 rounded-[20px]  relative group transition-all duration-300 cursor-pointer before:w-full before:block before:h-full before:border before:border-purple before:rounded-[20px] before:absolute before:left-0 before:top-0 before:z-0 before:scale-0 group-hover:before:scale-100 before:transition-all before:duration-500 before:origin-top-left after:w-full after:block after:h-full after:border after:border-purple after:rounded-[20px] after:absolute after:left-0 after:top-0 after:z-0 after:scale-0 group-hover:after:scale-100 after:transition-all after:duration-500 after:ease-linear after:origin-bottom-right price_card_bg"
    >
      <div className="rounded-[20px] m-[1px] price_card_bg p-5 sm:p-10 relative z-10 h-full min-h-[400px] grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="flex flex-col justify-center h-full">
          <p className="text-paragraph">{category}</p>
          <h3 className="case_card_title text-white text-24 font-semibold pt-0.5 line-clamp-2" title={title}>
            <Link to={`/case-studies/${slug || '#'}`}>{title}</Link>
          </h3>
          <p className="text-paragraph py-[30px] line-clamp-3" title={description}>{description}</p>

          <Link to={`/case-studies/${slug || '#'}`}>
            <div className="overflow-hidden flex gap-2 items-center justify-center border border-main-black/10 rounded-[41px] px-[30px] py-1.5 w-fit relative before:absolute before:z-0 before:w-full before:h-full before:bg-blue-seo before:scale-x-0 group-hover:before:scale-x-100 before:origin-right hover:before:origin-left before:transition-transform before:ease-out before:duration-300">
              <span className="relative z-10 font-semibold text-white">
                Read More
              </span>
              <svg
                className="relative z-10 transition-all duration-100"
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="transition-all duration-100 group-hover:stroke-white"
                  d="M1 10.5L4.79289 6.70711C5.12623 6.37377 5.29289 6.20711 5.29289 6C5.29289 5.79289 5.12623 5.62623 4.79289 5.29289L1 1.5"
                  stroke="#101828"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </Link>
        </div>
        <div className="overflow-hidden rounded-2xl h-full min-h-[400px]">
          <img src={image} alt={title} className="object-cover w-full h-full" />
        </div>
      </div>
    </div>
  );
}

export default function CaseStudyOne() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await projectService.getAllProjects();
        const data = response.data || response || [];
        // Take only the first 4 projects for the home page
        setProjects(data.slice(0, 4));
      } catch (error) {
        console.error("Error fetching home projects:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <section id="caseStudies" className="w-full pt-16 md:pb-[153px] pb-16">
      <div className="w-full mx-auto theme-container px-4">
        <div className="max-w-[661px] w-full flex flex-col items-center mx-auto">
          <h1 className="border text-chip border-purple/30 py-0.5 px-5 rounded-[30px] w-fit mb-5">
            Case Studies
          </h1>
          <h2 className="pt-5 font-semibold text-center text-white text-34 sm:text-48">
            We Have {projects.length}+ Projects Discover Our Case Studies
          </h2>
        </div>
        <div className="grid grid-cols-6 lg:grid-cols-12 gap-5 sm:gap-[30px] mt-10 md:mt-[70px]">
          {loading ? (
            <div className="col-span-full text-center py-10">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-purple"></div>
            </div>
          ) : projects.length > 0 ? (
            projects.map((project) => (
              <CaseCard
                key={project.id || project.slug}
                title={project.title}
                category={project.category || "Case Study"}
                image={project.image}
                description={project.overview}
                slug={project.slug}
              />
            ))
          ) : (
            <div className="col-span-full text-center py-10">
              <p className="text-gray-400">No case studies available.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
